import { JxtLoader } from '@jooxter/ui';

export const getLoader = () => (
  <div className="flex flex-1 h-full items-center justify-center">
    <JxtLoader />
  </div>
);
